module.exports = __webpack_public_path__ + "static/media/debbfa41-3ea8-466c-9174-de4e919598ed.f199fde1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/debbfa41-3ea8-466c-9174-de4e919598ed.eot
// module id = 98
// module chunks = 0